import React from 'react';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import NotificationPermissionDialog from '@client/components/mylounge/NotificationPermission/NotificationPermissionDialog';

export const NotificationPermissionWrapper = () => (
    <TranslationsScope path="notificationPermissionDialog">
        <NotificationPermissionDialog />
    </TranslationsScope>
);

export default NotificationPermissionWrapper;
